import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import Button from '@components/Shared/Buttons/Button';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';

import {
  Wrapper,
  Header,
  ButtonWrapper,
  ResetButton,
  LegalFooter,
} from './Outro.styled';

class Outro extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.visible !== nextProps.visible) {
      return true;
    }

    if (this.props.playing !== nextProps.playing) {
      return true;
    }

    return false;
  }

  render() {
    const { data } = this.props;
    if (!data) return null;

    return (
      <div id="unbuilt-outro">
        <Wrapper visible={this.props.visible} playing={this.props.playing}>
          <Header className="outro-header">{data.header}</Header>
          <ButtonWrapper>
            <div className="button-browse">
              <Button
                text="Browse Models"
                nextJSUrl="/find-a-home/"
                linkComponent={Link}
                automationId="unbuilt-outro-browse-models"
                onClick={() => {
                  pushGTMEvent('ch.cta_click', 'dtr_unbuilt_view_homes', {
                    location: 'Unbuilt Page',
                    category: 'home_search',
                    action: 'button',
                    label: 'dtr_unbuilt_view_homes',
                  });
                }}
              />
            </div>
            <div className="button-visit">
              <Button
                text="Visit a Home Center"
                buttonStyle="outlined"
                nextJSUrl="/locations/"
                linkComponent={Link}
                automationId="unbuilt-outro-visit-hc"
                onClick={() => {
                  pushGTMEvent('ch.cta_click', 'dtr_unbuilt_visit_hc', {
                    location: 'Unbuilt Page',
                    category: 'dealer_search',
                    action: 'button',
                    label: 'dtr_unbuilt_visit_hc',
                  });
                }}
              />
            </div>
          </ButtonWrapper>
        </Wrapper>

        <ResetButton
          onClick={this.props.reset}
          visible={this.props.visible}
          playing={this.props.playing}
        >
          Back to Start
        </ResetButton>
        <LegalFooter visible={this.props.visible}>
          <span>
            &copy; 1998-{new Date().getFullYear()} CMH Services, Inc. All rights
            reserved.{' '}
          </span>
          <span>
            <Link href="/legal">Legal</Link>
            <span> | </span>
            <Link href="/privacy">Privacy</Link>
            <span className="bar2"> | </span>
            <a className="ccpa" href="/privacy/ccpa/ca-resident-privacy-policy">
              Privacy Notice for California Residents
            </a>
          </span>
        </LegalFooter>
      </div>
    );
  }
}

Outro.propTypes = {
  data: PropTypes.shape({
    header: PropTypes.any,
  }),
  playing: PropTypes.any,
  reset: PropTypes.any,
  visible: PropTypes.any,
};

export default Outro;
